


















import { CellItem, GridItem } from '@/types';
import Vue, { PropType } from 'vue';

import GridItemC from './GridItem.vue';

export default Vue.extend({
  props: {
    rows: {
      type: Number,
      default: 0,
    },
    columns: {
      type: Number,
      default: 0,
    },
    orientation: {
      type: String,
      default: 'portrait',
    },
    value: {
      type: Array as PropType<CellItem[]>,
      default: () => [],
    },
    cellClass: {
      type: Function as PropType<(cell: CellItem) => string>,
      default: () => () => '',
    },
    toggle: {
      type: Function as PropType<(cell: CellItem) => void>,
      default: () => () => undefined,
    },
  },

  components: {
    GridItem: GridItemC,
  },

  computed: {
    grid(): GridItem[] {
      const size = this.rows * this.columns;
      let col = 0,
        row = 0;
      let gridIndex = 1;

      const source: CellItem[] = this.value;

      return new Array(size).fill(null).map((d, index) => {
        col = index % this.columns;
        row = Math.floor(index / this.columns);
        let value = source.some(item => item.col === col && item.row === row);

        return {
          col,
          row,
          index: value ? gridIndex++ : gridIndex,
          value,
        };
      });
    },

    size(): Record<string, any> {
      const size = 100 / this.columns;
      const maxSize = this.orientation === 'VERTICAL' ? '40' : '60';

      return { 'flex-basis': `calc(${size}% - 2px)`, 'max-width': `${maxSize}px` };
    },

    aspectRatio(): number {
      if (this.orientation === 'portrait') {
        return 1 / 1.65;
      }

      if (this.columns <= 8) return 1.65;

      return 1;
    },
  },
});
